
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitch02On as ObiSwitch02OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-02-on.js';
 
 
 

 
 export const ObiSwitch02On = createComponent({
   react: React,
   tagName: 'obi-switch-02-on',
   elementClass: ObiSwitch02OnElement,
   events: {
     
   }
  });
 
 